var React = require('react');

function PieChartInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"64","height":"64","rx":"16","fill":"#1565D8","opacity":".06","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32.031 32.8h13.6a.8.8 0 0 1 .8.8c0 8.395-6.805 15.2-15.2 15.2s-15.2-6.805-15.2-15.2c0-8.394 6.806-15.2 15.2-15.2a.8.8 0 0 1 .8.8v13.6z","fill":"#1565D8","key":1}),React.createElement("path",{"opacity":".3","d":"M49.634 28.8a.8.8 0 0 1-.8.8h-12.8a.8.8 0 0 1-.8-.8V16a.8.8 0 0 1 .8-.8c7.511 0 13.6 6.088 13.6 13.6z","fill":"#1565D8","key":2})]);
}

PieChartInline.defaultProps = {"viewBox":"0 0 64 64","width":"64","height":"64","fill":"none"};

module.exports = PieChartInline;

PieChartInline.default = PieChartInline;
